<script>
  // Перенос Row из lib/ui.tsx.
  export let wrap = false;
  let className = '';
  export { className as class };
  export let style = undefined;
</script>

<div class={'ui-row' + (wrap ? ' wrap' : '') + (className ? ' ' + className : '')} {style}><slot /></div>
